<template>
  <v-data-table
    :fixed-header="false"
    :height="undefined"
    v-bind="dataTableAttrs"
    :headers="headers"
    :items="list"
    :loading="isLoading"
    :options.sync="options"
    :server-items-length="total"
    :items-per-page.sync="itemsPerPage"
    v-model="selectedItems"
    @update:items-per-page="handleItemsPerPageUpdated"
  >
    <!-- eslint-disable-next-line -->
    <template v-slot:item.edit="{ item }">
      <router-link
        class="btn btn-icon btn-sm btn-clean"
        :to="{
          name: 'expenses.invoices.edit',
          params: { id: item.id },
        }"
      >
        <i class="menu-icon mdi mdi-pencil"></i>
      </router-link>
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.amount="{ value }">
      <rs-table-cell-number price :value="value" />
    </template>

    <!-- eslint-disable-next-line -->
    <template v-slot:item.billed_on="{ value }">
      <rs-table-cell-date :value="value" />
    </template>
  </v-data-table>
</template>

<script>
import hasDataTable from "@/view/mixins/hasDataTable";

export default {
  mixins: [hasDataTable],
  props: {
    projectId: {
      type: Number,
      required: true,
      default: null,
    },
  },
  watch: {
    options: {
      handler() {
        this.loadList();
      },
      deep: true,
    },
    projectId: {
      handler() {
        this.loadList();
      },
      immediate: true,
    },
  },
  data() {
    return {
      options: {
        sortBy: [],
        sortDesc: [],
      },
      headers: [
        {
          text: "",
          value: "edit",
          searchable: false,
          sortable: false,
          width: "30px",
          align: "center",
        },
        {
          text: this.$t("labels.date"),
          value: "billed_on",
          searchable: "date",
        },
        {
          text: "Belge No",
          value: "document_no",
          searchable: "text",
        },
        {
          text: "Tedarikçi Adı",
          value: "provider",
          searchable: "text",
        },
        {
          text: this.$t("labels.amount"),
          value: "amount",
          searchable: "number",
          align: "end",
        },
      ],
    };
  },
  methods: {
    loadList() {
      this.list = [];
      this.footTotals = [];
      this.selectedItems = [];

      if (this.isLoading || !this.projectId) {
        return;
      }

      this.isLoading = true;

      const params = Object.assign(
        this.buildSearchParams(this.search, this.options)
      );

      params.project = this.projectId;
      // params.list_type = this.listType;

      this.$api
        .query("expense/invoices", {
          params,
        })
        .then((response) => {
          const list = [];

          if (response.data && response.data.data) {
            for (const item of response.data.data) {
              list.push(item);
            }
          }

          this.list = list;

          if (response.data && response.data.meta) {
            this.total = response.data.meta.total;
            this.options.page = response.data.meta.current_page;
            this.itemsPerPage = response.data.meta.per_page;
            this.options.itemsPerPage = this.itemsPerPage;
            this.footTotals = response.data.meta.totals;

            this.$emit("update:total", this.footTotals.amount);
          }
        })
        .catch((error) => {
          this.handleError(error);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
